export function extractTimeValue(input?: string | null): string | null {
  if (!input || typeof input !== "string") return null;

  const hasTSeparator = input.includes("T");
  const timePart = hasTSeparator ? input.split("T")[1] : input.split(" ")[1];
  if (!timePart) return null;

  const withoutTimezone = timePart.replace(/([+-]\d{2}:\d{2}|Z)$/i, "");
  const withoutFractionalSeconds = withoutTimezone.split(".")[0];

  return withoutFractionalSeconds || null;
}